@import '../../../../../../../constants/spacing.module.less';
@import '../../new-lineup-plan-grid-shared-styles.module.less';

.plan-analytics-license-count {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: @analytics-license-label-grid-area / @analytics-license-grid-area;
  gap: @space-0;
}

.analytics-license-label {
  grid-area: @analytics-license-label-grid-area;
  color: var(--gray-212c36);
}

.analytics-license-input {
  grid-area: @analytics-license-grid-area;
  height: 32px;
  gap: @space-4;
  padding: @space-4 @space-4 @space-4 @space-8;
  font-size: 14px;

  > input {
    text-align: left;
  }
}
